import Vue from 'vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App.vue'

// Import the Auth0 configuration
//import { domain, clientId, audience } from "../auth_config.json";

var domain = process.env.VUE_APP_AUTH0_DOMAIN;
var clientId = process.env.VUE_APP_AUTH0_CLIENTID;
var audience = process.env.VUE_APP_AUTH0_AUDIENCE;


// Import the plugin here
import { Auth0Plugin } from "./auth";

import { GridPlugin } from '@syncfusion/ej2-vue-grids';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { ComboBoxPlugin } from '@syncfusion/ej2-vue-dropdowns';
import i18n from './i18n'
import './registerServiceWorker'



// Install the authentication plugin here
Vue.use(
  Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
}
);

Vue.use(BootstrapVue);

Vue.use(GridPlugin);
Vue.use(DatePickerPlugin);
Vue.use(ComboBoxPlugin);

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
